import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/forsport/images/logo-brand.svg';

export default function Index() {
  return <Image src={logo} maxW="100px" />;
}
